import { render } from "./OrderPaymentCancelPage.vue?vue&type=template&id=048a2146&scoped=true&ts=true"
import script from "./OrderPaymentCancelPage.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentCancelPage.vue?vue&type=script&lang=ts"

import "./OrderPaymentCancelPage.vue?vue&type=style&index=0&id=048a2146&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048a2146"]])

export default __exports__